(() => {
  const STYLE_ID = 'odd-one-preview-polish-style';
  const FINAL_CLASS = 'odd-one-preview-final';
  const UNDERLAY_CLASS = 'odd-one-preview-underlay';
  const APPLYING_CLASS = 'is-odd-applying';
  const states = new WeakMap();

  const styleText = `
    .odd-one-design-modal__result-image { background: transparent !important; }

    .odd-one-native-preview__garment > img {
      grid-area: 1 / 1;
    }

    .odd-one-native-preview__garment > .${UNDERLAY_CLASS} {
      z-index: 0;
      pointer-events: none;
    }

    .odd-one-native-preview__garment > .${FINAL_CLASS} {
      z-index: 1;
      transition: opacity .2s ease;
    }

    .odd-one-native-preview[data-flattened='true'] .odd-one-native-preview__art {
      z-index: 2;
    }

    .odd-one-native-preview.${APPLYING_CLASS} .${FINAL_CLASS} {
      opacity: 0;
    }

    .odd-one-native-preview .${FINAL_CLASS}.is-odd-final-ready {
      opacity: 1;
    }

    .odd-one-native-preview__apply-loader {
      position: absolute;
      inset: 0;
      z-index: 30;
      display: none;
      place-items: center;
      pointer-events: none;
      background: transparent;
    }

    .odd-one-native-preview.${APPLYING_CLASS} .odd-one-native-preview__apply-loader {
      display: grid;
    }

    .odd-one-native-preview__apply-loader-inner {
      display: grid;
      justify-items: center;
      gap: 0;
      color: #111;
      font-size: 12px;
      font-weight: 700;
      line-height: 1.2;
      text-align: center;
      text-shadow: 0 1px 2px #fff, 0 0 8px #fff;
    }

    .odd-one-native-preview__apply-cat {
      width: 96px;
      height: 96px;
    }

    .odd-one-native-preview__apply-cat svg {
      display: block;
      width: 100%;
      height: 100%;
      overflow: visible;
    }

    @media (max-width: 749px) {
      .odd-one-native-preview__apply-cat {
        width: 82px;
        height: 82px;
      }
      .odd-one-native-preview__apply-loader-inner {
        font-size: 11px;
      }
    }
  `;

  const loaderMarkup = `
    <div class="odd-one-native-preview__apply-loader" role="status" aria-live="polite">
      <div class="odd-one-native-preview__apply-loader-inner">
        <div class="odd-one-native-preview__apply-cat" aria-hidden="true">
          <svg viewBox="0 0 400 400" focusable="false">
            <g class="odd-one-loader-cat">
              <g class="odd-one-loader-tail">
                <path d="M189.2 138.9 A62 62 0 0 0 178.8 258.3" fill="none" stroke="#111" stroke-width="12" stroke-linecap="round"/>
              </g>
              <g transform="rotate(-85 200 200)">
                <ellipse class="odd-one-loader-paw odd-one-loader-paw--a" cx="284" cy="200" rx="9" ry="5" fill="#111"/>
                <ellipse class="odd-one-loader-paw odd-one-loader-paw--b" cx="240" cy="200" rx="9" ry="5" fill="#111"/>
              </g>
              <g transform="rotate(-38 200 200)">
                <ellipse class="odd-one-loader-paw odd-one-loader-paw--b" cx="284" cy="200" rx="9" ry="5" fill="#111"/>
                <ellipse class="odd-one-loader-paw odd-one-loader-paw--a" cx="240" cy="200" rx="9" ry="5" fill="#111"/>
              </g>
              <path d="M189.2 138.9 A62 62 0 0 1 261.8 194.6" fill="none" stroke="#111" stroke-width="40" stroke-linecap="round"/>
              <path d="M196 129 A72 72 0 0 1 252 158" fill="none" stroke="#3a3a3a" stroke-width="4" stroke-linecap="round" opacity=".7"/>
              <g class="odd-one-loader-head" style="transform: translate(263px,210px) rotate(98deg)">
                <polygon points="-4,-12 -14,-25 6,-17" fill="#111"/>
                <polygon points="-4,12 -14,25 6,17" fill="#111"/>
                <polygon points="-5,-13 -11,-20 1,-16" fill="#c98a9a"/>
                <polygon points="-5,13 -11,20 1,16" fill="#c98a9a"/>
                <circle r="19" fill="#111"/>
                <ellipse cx="7" cy="-7" rx="4" ry="3.2" fill="#f2d31b"/>
                <ellipse cx="7" cy="7" rx="4" ry="3.2" fill="#f2d31b"/>
                <ellipse cx="7.6" cy="-7" rx="1" ry="3" fill="#111"/>
                <ellipse cx="7.6" cy="7" rx="1" ry="3" fill="#111"/>
                <circle cx="17" cy="0" r="2.2" fill="#e58fa5"/>
                <g stroke="#bbb" stroke-width="1" stroke-linecap="round">
                  <line x1="14" y1="-4" x2="28" y2="-12"/>
                  <line x1="14" y1="-2" x2="29" y2="-5"/>
                  <line x1="14" y1="4" x2="28" y2="12"/>
                  <line x1="14" y1="2" x2="29" y2="5"/>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <span>Applying your design…</span>
      </div>
    </div>`;

  const injectStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = styleText;
    document.head.appendChild(style);
  };

  const stateFor = (preview) => {
    let state = states.get(preview);
    if (!state) {
      state = { lastBaseSrc: '', underlay: null, finishTimer: 0 };
      states.set(preview, state);
    }
    return state;
  };

  const ensureLoader = (preview) => {
    if (!preview || preview.querySelector('.odd-one-native-preview__apply-loader')) return;
    preview.insertAdjacentHTML('beforeend', loaderMarkup);
  };

  const removeUnderlay = (preview) => {
    const state = stateFor(preview);
    if (state.underlay) {
      state.underlay.remove();
      state.underlay = null;
    }
  };

  const stopLoading = (preview, restoreImage = false) => {
    if (!preview) return;
    preview.classList.remove(APPLYING_CLASS);
    const img = preview.querySelector('.odd-one-native-preview__garment > img:not(.' + UNDERLAY_CLASS + ')');
    if (img && restoreImage) {
      img.classList.remove(FINAL_CLASS, 'is-odd-final-ready');
      img.style.opacity = '';
    }
    if (restoreImage) removeUnderlay(preview);
  };

  const beginLoading = (preview) => {
    if (!preview) return;
    ensureLoader(preview);
    preview.classList.add(APPLYING_CLASS);
  };

  const finishFinalImage = (preview, img) => {
    if (!preview || !img || !String(img.src || '').startsWith('blob:')) return;
    const state = stateFor(preview);
    window.clearTimeout(state.finishTimer);

    window.requestAnimationFrame(() => {
      img.classList.add('is-odd-final-ready');
      preview.classList.remove(APPLYING_CLASS);
      state.finishTimer = window.setTimeout(() => removeUnderlay(preview), 230);
    });
  };

  const prepareFinalImage = (preview, img) => {
    if (!preview || !img) return;
    const src = String(img.getAttribute('src') || img.src || '');
    if (!src.startsWith('blob:')) return;

    const state = stateFor(preview);
    beginLoading(preview);

    if (!state.underlay && state.lastBaseSrc) {
      const underlay = document.createElement('img');
      underlay.className = UNDERLAY_CLASS;
      underlay.alt = '';
      underlay.setAttribute('aria-hidden', 'true');
      underlay.src = state.lastBaseSrc;
      img.parentNode?.insertBefore(underlay, img);
      state.underlay = underlay;
    }

    img.classList.add(FINAL_CLASS);
    img.classList.remove('is-odd-final-ready');

    if (img.complete && img.naturalWidth > 0) {
      finishFinalImage(preview, img);
    }
  };

  const preparePreview = (preview) => {
    if (!(preview instanceof HTMLElement)) return;
    ensureLoader(preview);

    const img = preview.querySelector('.odd-one-native-preview__garment > img:not(.' + UNDERLAY_CLASS + ')');
    if (!img || img.dataset.oddPreviewPolishBound === 'true') return;
    img.dataset.oddPreviewPolishBound = 'true';

    img.addEventListener('load', () => {
      const src = String(img.getAttribute('src') || img.src || '');
      if (src.startsWith('blob:')) finishFinalImage(preview, img);
    });

    img.addEventListener('error', () => {
      stopLoading(preview, true);
    });
  };

  const existingPreviews = () =>
    document.querySelectorAll('.odd-one-native-preview').forEach(preparePreview);

  injectStyles();
  existingPreviews();

  const observer = new MutationObserver((records) => {
    // First capture the blank mockup source before a blob URL replaces it.
    records.forEach((record) => {
      if (record.type !== 'attributes' || record.attributeName !== 'src') return;
      const img = record.target;
      if (!(img instanceof HTMLImageElement)) return;
      if (!img.matches('.odd-one-native-preview__garment > img:not(.' + UNDERLAY_CLASS + ')')) return;

      const preview = img.closest('.odd-one-native-preview');
      if (!preview) return;
      const oldSrc = String(record.oldValue || '');
      if (oldSrc && !oldSrc.startsWith('blob:') && !oldSrc.startsWith('data:')) {
        stateFor(preview).lastBaseSrc = oldSrc;
      }
    });

    records.forEach((record) => {
      if (record.type === 'childList') {
        record.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches('.odd-one-native-preview')) preparePreview(node);
          node.querySelectorAll?.('.odd-one-native-preview').forEach(preparePreview);
        });
        return;
      }

      if (record.type !== 'attributes') return;

      if (record.attributeName === 'data-flattened' && record.target instanceof HTMLElement) {
        const preview = record.target;
        if (!preview.matches('.odd-one-native-preview')) return;
        preparePreview(preview);

        if (preview.dataset.flattened === 'loading') {
          beginLoading(preview);
        } else if (preview.dataset.flattened === 'false') {
          stopLoading(preview, true);
        } else if (preview.dataset.flattened === 'true') {
          const img = preview.querySelector('.odd-one-native-preview__garment > img:not(.' + UNDERLAY_CLASS + ')');
          if (img) prepareFinalImage(preview, img);
        }
        return;
      }

      if (record.attributeName === 'src' && record.target instanceof HTMLImageElement) {
        const img = record.target;
        if (!img.matches('.odd-one-native-preview__garment > img:not(.' + UNDERLAY_CLASS + ')')) return;
        const preview = img.closest('.odd-one-native-preview');
        if (!preview) return;
        preparePreview(preview);

        const src = String(img.getAttribute('src') || img.src || '');
        if (src.startsWith('blob:')) {
          prepareFinalImage(preview, img);
        } else if (src && !src.startsWith('data:')) {
          stateFor(preview).lastBaseSrc = src;
          img.classList.remove(FINAL_CLASS, 'is-odd-final-ready');
          img.style.opacity = '';
        }
      }
    });
  });

  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeOldValue: true,
    attributeFilter: ['data-flattened', 'src']
  });
})();
